import React, { useEffect, useState } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import Hero from './components/Hero';
import Services from './components/Services';
import Contact from './components/Contact';

const App: React.FC = () => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };

    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('scroll', handleScroll);

    // Reveal animations on scroll
    const revealElements = () => {
      const reveals = document.querySelectorAll('.reveal');
      reveals.forEach((el) => {
        const windowHeight = window.innerHeight;
        const elementTop = el.getBoundingClientRect().top;
        const elementVisible = 150;
        
        if (elementTop < windowHeight - elementVisible) {
          el.classList.add('active');
        }
      });
    };

    window.addEventListener('scroll', revealElements);
    revealElements();

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('scroll', revealElements);
    };
  }, []);

  return (
    <div className="min-h-screen bg-dark-950 relative overflow-hidden">
      {/* Cursor follower */}
      <div 
        className="cursor-follower hidden lg:block"
        style={{
          transform: `translate(${mousePosition.x - 200}px, ${mousePosition.y - 200}px)`
        }}
      />
      
      {/* Ambient background orbs */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden">
        <div 
          className="orb w-96 h-96 bg-maize-500/20"
          style={{ top: '10%', left: '5%', animationDelay: '0s' }}
        />
        <div 
          className="orb w-80 h-80 bg-maize-400/15"
          style={{ top: '60%', right: '10%', animationDelay: '-5s' }}
        />
        <div 
          className="orb w-64 h-64 bg-maize-600/10"
          style={{ bottom: '20%', left: '30%', animationDelay: '-10s' }}
        />
      </div>

      {/* Header */}
      <Header scrolled={scrolled} />
      
      {/* Main content */}
      <main className="relative z-10">
        <Hero />
        <Services />
        <Contact />
      </main>
      
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default App;